import React from "react";
import { motion } from "framer-motion";
import { BadgeCheckIcon, StarIcon } from "lucide-react";
import { reviews, reviewSummary } from "../data/reviews";
const STAR_GREEN = "bg-[#00B67A]";
function StarRow({
  size = "md",
  partialLast = false
}: {
  size?: "sm" | "md";
  partialLast?: boolean;
}) {
  const box = size === "md" ? "h-9 w-9" : "h-5 w-5";
  const icon = size === "md" ? "h-6 w-6" : "h-3.5 w-3.5";
  return <div className="flex gap-1" aria-hidden="true" data-id="element-338" data-mp="1bi6r49vnbc2a">
      {[0, 1, 2, 3, 4].map(i => <span key={i} className={`relative flex items-center justify-center overflow-hidden bg-[#DCDCE6] ${box}`} data-id="element-339" data-mp="16pdq9x3asnvh">
          <span className={`absolute inset-y-0 left-0 ${STAR_GREEN}`} style={{
        width: partialLast && i === 4 ? "90%" : "100%"
      }} data-id="element-340" data-mp="11s3orj2mwlra" />
          <StarIcon className={`relative fill-white text-white ${icon}`} data-id="element-341" data-mp="wqeei5n8kc49" />
        </span>)}
    </div>;
}
export function ReviewsSection() {
  return <section aria-labelledby="opiniones-title" className="mt-16" data-id="element-342" data-mp="nsvp6p2k7bmk">
      <motion.div className="flex flex-col items-center text-center" initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: "-60px"
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-343" data-mp="3lywjebiwrwqk">
        <h2 id="opiniones-title" className="font-serif text-3xl font-semibold text-forest sm:text-4xl" data-id="element-344" data-mp="3gzjpx7xj7rf0">
          {reviewSummary.label}
        </h2>
        <div className="mt-4" data-id="element-345" data-mp="8l1lrhapow0o">
          <StarRow partialLast data-id="element-346" data-mp="8hnnak5656yi" />
        </div>
        <p className="mt-4 text-base text-cocoa" data-id="element-347" data-mp="dj37yb3fpbgd">
          Valorado con <strong className="font-bold" data-id="element-348" data-mp="3vog6jtdnmcr8">{reviewSummary.rating}</strong> de 5 estrellas
        </p>
        <p className="mt-1 text-sm text-cocoa-soft" data-id="element-349" data-mp="3vqsow7nbqp4t">
          Basado en <strong className="font-semibold text-cocoa" data-id="element-350" data-mp="4glhfkgqxwnk">{reviewSummary.count} opiniones</strong> de clientas con
          compra verificada
        </p>
      </motion.div>

      <div className="mt-8 grid gap-5 sm:grid-cols-2" data-id="element-351" data-mp="2p8nnl193l55z">
        {reviews.map((r, i) => <motion.article key={r.name} className="flex flex-col rounded-2xl border border-cream-dark bg-white p-5" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-40px"
      }} transition={{
        duration: 0.3,
        delay: i % 2 * 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-352" data-mp="usovnet5w734" data-mpi={i}>
            <div className="flex items-center justify-between gap-3" data-id="element-353" data-mp="c1ebrhlusukq">
              <StarRow size="sm" data-id="element-354" data-mp="bzl3xyzi84b5" />
              <span className="text-xs text-cocoa-faint" data-id="element-355" data-mp="721m6p3ll9eg">{r.when}</span>
            </div>
            <h3 className="mt-3 text-base font-bold text-cocoa" data-id="element-356" data-mp="23874s8nxac6">{r.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-cocoa-soft" data-id="element-357" data-mp="25b8g8f9mpw7">{r.text}</p>
            <div className="mt-auto flex items-center gap-3 border-t border-cream-dark pt-4" data-id="element-358" data-mp="3u93sbd1u068n">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-blush-100 text-sm font-bold text-rose-700" data-id="element-359" data-mp="1wgpy6p8a0pby">
                {r.name.charAt(0)}
              </span>
              <div className="min-w-0" data-id="element-360" data-mp="3ad12srrnwy47">
                <p className="text-sm font-semibold text-cocoa" data-id="element-361" data-mp="3fcnegwrue6aw">{r.name}</p>
                <p className="text-xs text-cocoa-faint" data-id="element-362" data-mp="3faj35trm650l">{r.meta}</p>
              </div>
              <span className="ml-auto inline-flex shrink-0 items-center gap-1 text-xs font-semibold text-[#00B67A]" data-id="element-363" data-mp="3k45hrrhc8iz1">
                <BadgeCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-364" data-mp="3o6s1t67rozlo" />
                Compra verificada
              </span>
            </div>
          </motion.article>)}
      </div>
    </section>;
}